import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";

const PaymentSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Extract session_id from URL query parameters
  const queryParams = new URLSearchParams(location.search);
  const sessionId = queryParams.get("session_id");

  // Handle navigation to dashboard
  const handleReturnToDashboard = () => {
    window.location.href = "/";
  };

  return (
    <>
      <style>
        {`
          .success-container {
            padding: 2rem 1rem;
            width: 100%;
            min-height: 100vh;
            margin: 0 auto;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: center;
          }
          .success-header {
            margin-bottom: 2rem;
          }
          .success-header h2 {
            font-size: 2rem;
            font-weight: 600;
            color: #1f2937;
            margin-bottom: 0.5rem;
          }
          .success-header p {
            font-size: 1rem;
            color: #6b7280;
            max-width: 600px;
          }
          .success-header .session-id {
            font-size: 0.875rem;
            color: #9a2d07;
            margin-top: 0.5rem;
            word-break: break-all;
          }
          .success-icon {
            font-size: 4rem;
            color: #9a2d07;
            margin-bottom: 1rem;
          }
          .dashboard-button {
            display: inline-flex;
            align-items: center;
            gap: 0.5rem;
            padding: 0.75rem 1.5rem;
            background: #9a2d07;
            color: white;
            border: none;
            border-radius: 0.5rem;
            font-size: 1rem;
            font-weight: 500;
            cursor: pointer;
            transition: background 0.3s;
          }
          .dashboard-button:hover {
            background: #9a2d07;
          }

          /* Tablet styles */
          @media (max-width: 1024px) {
            .success-container {
              padding: 1.5rem 1rem;
            }
            .success-header h2 {
              font-size: 1.75rem;
            }
            .success-header p {
              font-size: 0.875rem;
            }
          }

          /* Mobile landscape and smaller tablets */
          @media (max-width: 768px) {
            .success-container {
              padding: 1rem 0.75rem;
            }
            .success-header h2 {
              font-size: 1.5rem;
            }
            .success-header p {
              font-size: 0.875rem;
            }
            .success-icon {
              font-size: 3rem;
            }
          }

          /* Mobile portrait */
          @media (max-width: 480px) {
            .success-container {
              padding: 0.75rem 0.5rem;
            }
            .success-header {
              margin-bottom: 1.5rem;
            }
            .success-header h2 {
              font-size: 1.25rem;
            }
            .success-header p {
              font-size: 0.8rem;
            }
            .success-header .session-id {
              font-size: 0.75rem;
            }
            .dashboard-button {
              width: 100%;
              justify-content: center;
            }
          }

          /* Very small screens */
          @media (max-width: 360px) {
            .success-container {
              padding: 0.5rem 0.25rem;
            }
            .success-icon {
              font-size: 2.5rem;
            }
          }

          /* Large screens */
          @media (min-width: 1400px) {
            .success-container {
              padding: 2rem 2rem;
            }
            .success-header h2 {
              font-size: 2.25rem;
            }
            .success-header p {
              font-size: 1.125rem;
            }
          }

          /* Extra large screens */
          @media (min-width: 1920px) {
            .success-container {
              padding: 2rem 3rem;
            }
            .success-header h2 {
              font-size: 2.5rem;
            }
            .success-header p {
              font-size: 1.25rem;
            }
          }
        `}
      </style>

      <div className="success-container">
        <Icon icon="mdi:check-circle" className="success-icon" />
        <div className="success-header">
          <h2>Thanks for Your Subscription!</h2>
          <p>
            Your payment was successful, and your subscription has been
            activated. Enjoy full access to PARK EASE VALET!
          </p>
          {/* {sessionId && <p className="session-id">Session ID: {sessionId}</p>} */}
        </div>
        <button className="dashboard-button" onClick={handleReturnToDashboard}>
          <Icon icon="mdi:home" />
          Return to Dashboard
        </button>
      </div>
    </>
  );
};

export default PaymentSuccess;
